import * as React from "react";
import { Fade } from "@chakra-ui/react";
import { Loading } from "./components/Loading";
import { Playground } from "./components/Playground";
import {
  IGameData,
  IGetGameRequest,
  IPopup,
  IStyle,
} from "./interface/Interface";
import { useEffect } from "react";
import {
  GetDailyCheckInGameData,
  GetMemberCodeFromQueryString,
} from "./service/CommonService";

const defaultData: IGameData = {
  iOSDownloadLink: "",
  id: 0,
  code: "",
  allowLineShare: false,
  allowFBShare: false,
  allowAndroidDownload: false,
  androidDownloadLink: "",
  allowiOSDownload: false,
  style: {} as IStyle,
  awardList: [],
  timeStamp: "",
  assetsMappingList: {},
  languageList: {},
  contentList: [],
  popup: {} as IPopup,
  redirectUrl: "",
  officialUrl: "",
};

export const App = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [gameData, setGameData] = React.useState<IGameData>(defaultData);

  const isWYSIWYG =
    new URLSearchParams(window.location.search).get("wysiwyg") === "true";

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);

      const code = new URLSearchParams(window.location.search).get("gameid");
      const memberCode = GetMemberCodeFromQueryString();
      const isPreview =
        new URLSearchParams(window.location.search).get("preview") === "true";

      try {
        const request = {
          code: code,
          memberCode: memberCode,
          isPreview: isPreview,
        } as IGetGameRequest;

        const result = await GetDailyCheckInGameData(request);

        if (result != null) {
          setGameData(result);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    if (isWYSIWYG) {
      setIsLoading(false);
    } else {
      getData();
    }
  }, [isWYSIWYG]);

  ///iframe
  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.data.type === "webpackWarnings") {
        return;
      }

      const data = event.data as IGameData;
      setGameData(data);
    };

    const isListen =
      new URLSearchParams(window.location.search).get("wysiwyg") === "true";

    if (isListen) {
      window.addEventListener("message", handleMessage);
    }

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  if (isLoading) {
    return (
      <>
        <Loading></Loading>
      </>
    );
  }

  return (
    <>
      <Fade
        in={!isLoading}
        transition={{ enter: { duration: 0.5 } }}
        style={{ height: "100%" }}
      >
        {gameData && <Playground data={gameData} />}
      </Fade>
    </>
  );
};
